<template>
  <div>
    <ActitiveTabcomponent :tabs="tabItems" :defaultTab="activeTab" @tab-changed="handleTabChange">
      <template #tab-buttons>
        <div v-if="activeTab === 'templates'" class="flex justify-end items-center pr-4">
          <Loader v-if="fetchingTemplates" />
          <v-icon
            v-else
            color="blue"
            v-tooltip="{ text: 'Refresh' }"
            class="cursor-pointer border border-gray-300 px-2 rounded"
            @click="onRefreshTemplates"
            >mdi-replay</v-icon
          >
          <v-btn
            @click="onAddNotiTemplate"
            color="primary"
            variant="flat"
            class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded shadow-sm normal-case"
          >
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </div>
        <div v-else-if="activeTab === 'notifications'" class="w-full">
          <div class="flex items-center justify-between">
            <div v-if="filteredNotificationCategory.length > 1">
              <v-autocomplete
                v-model="selectedCategory"
                label="Select Category"
                placeholder="Select Category"
                :items="filteredNotificationCategory"
                item-text="category"
                item-value="_id"
                class="pr-2 filter-column"
                hide-details
                outlined
                dense
                clearable
                @change="handleCategoryChange"
              >
              </v-autocomplete>
            </div>
            <div>
              <v-autocomplete
                v-model="selectRead"
                :items="notificationRead"
                hide-details
                outlined
                dense
                clearable
                label="Select Read"
                class="filter-column"
                placeholder="Select Read"
                item-text="label"
                item-value="value"
                @change="handleCategoryChange"
              ></v-autocomplete>
            </div>
          </div>
        </div>
        <div v-else-if="activeTab === 'letters'" class="flex justify-end items-center pr-4">
          <v-btn
            @click="onCreateLetter"
            color="primary"
            variant="flat"
            class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded shadow-sm normal-case"
          >
            <v-icon left>mdi-plus</v-icon>
            Create
          </v-btn>
        </div>
        <div v-else-if="activeTab === 'triggers'" class="flex justify-end items-center pr-4">
          <v-btn
            @click="onCreateTrigger"
            color="primary"
            variant="flat"
            class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded shadow-sm normal-case"
          >
            <v-icon left>mdi-plus</v-icon>
            Create Trigger
          </v-btn>
        </div>
        <div></div>
      </template>

      <template v-for="tab in visibleTabs" v-slot:[tab.key]="">
        <div v-if="!isLoad">
          <v-main style="padding: 0px">
            <component
              :is="tab.component"
              ref="tabComponent"
              :selected-category="selectedCategory"
              :select-read="selectRead"
              @show-add-template-dialog="onShowAddTemplateDialog"
              @refresh-templates="onRefreshTemplates"
              @edit-template="onEditTemplate"
              @update-stats="handleStatsUpdate"
            />
          </v-main>
        </div>
        <div v-else class="loading-container">
          <v-progress-circular
            :color="$vuetify.theme.currentTheme.primary"
            indeterminate
            :size="50"
            :width="5"
          ></v-progress-circular>
          <div class="mt-2"><span>Please Wait...</span></div>
        </div>
      </template>
    </ActitiveTabcomponent>

    <!-- Add Template Dialog - Moved from NotificationCard to here -->
    <v-dialog v-model="addTemplateDialogVisible" persistent width="1400px">
      <AddTemplate
        :templateTriggersList="templateTriggersList"
        :allTriggers="allTriggers"
        :editingTemplate="editingTemplate"
        @close="addTemplateDialogVisible = false"
        @template-submitted="onTemplateSubmitted"
      />
    </v-dialog>
  </div>
</template>

<script>
import Notifications from '~/components/Workforce/Notifications/Notifications.vue'
import ReimbursementTable from '~/components/Workforce/Notifications/ReimbursementTable.vue'
import { isModuleVisible, isAnyFeatureAllowed } from '@/utils/common'
import AddTemplate from '@/components/Workforce/Settings/OrgConfigComponents/PlatformIntegrations/AddTemplate.vue'
import LetterTemplates from '@/components/Workforce/Notifications/LetterTemplates.vue'
import TemplateTriggers from '@/components/Workforce/Notifications/TemplateTriggers.vue'
import {
  TAB_ITEMS,
  notificationTriggersOptions,
  getAllNotificationTriggers
} from '@/utils/workforce/constants'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
// import NotificationCard from '~/components/Workforce/Settings/OrgConfigComponents/NotificationIntegration/index.vue'
import Loader from '@/components/UI/Loader.vue'

export default {
  name: 'SettingsPage',
  layout: 'Workforce/default',
  components: {
    Notifications,
    AddTemplate,
    // NotificationCard,
    LetterTemplates,
    TemplateTriggers,
    ActitiveTabcomponent,
    Loader
  },
  data() {
    return {
      orgCode: this.$storage.getUniversal('organization_code'),
      isLoad: true,
      // Add template dialog data
      addTemplateDialogVisible: false,
      editingTemplate: null,
      fetchingTemplates: false,
      templateTriggersList: notificationTriggersOptions,
      // Notification filter data
      selectedCategory: null,
      selectRead: false,
      notificationRead: [
        { label: 'Read', value: true },
        { label: 'Not Read', value: false }
      ],
      notificationCategoryMap: {
        INVENTORY: 'SELLS',
        AMC: 'AMC',
        COMPLAINT: 'SELLS',
        LEAVE: 'LEAVE_MANAGEMENT'
      },
      notificationStats: []
    }
  },

  computed: {
    tabItems() {
      return TAB_ITEMS.NOTIFICATION.filter((tab) => {
        if (tab.key === 'alerts') {
          return this.isFeatureVisible('SELLS', 'LEAVE_MANAGEMENT')
        }
        return tab.visibility
      }).map((tab) => ({
        ...tab,
        label: tab.name,
        icon: tab.icon || 'mdi-bell',
        component: tab.component
      }))
    },
    activeTab() {
      return this.$route.query.activeTab || this.defaultTabKey
    },
    visibleTabs() {
      return this.tabItems.filter((tab) => tab.visibility)
    },
    defaultTabKey() {
      return this.visibleTabs.length > 0 ? this.visibleTabs[0].key : 'notifications'
    },
    allTriggers() {
      return getAllNotificationTriggers()
    },
    filteredNotificationCategory() {
      return Object.entries(this.notificationCategoryMap)
        .filter(([_, moduleName]) => isModuleVisible(moduleName) || isAnyFeatureAllowed(moduleName))
        .map(([category]) => ({
          category: category,
          _id: category
        }))
    }
  },
  methods: {
    handleTabChange(tabKey) {
      if (this.$route.query.activeTab !== tabKey) {
        this.$router.replace({
          query: { ...this.$route.query, activeTab: tabKey }
        })
      }
    },
    isFeatureVisible(module, feature) {
      return isModuleVisible(module) || isAnyFeatureAllowed(feature)
    },
    // Template management methods
    onAddNotiTemplate() {
      // Reset editing template to null for a clean add form
      this.editingTemplate = null
      this.addTemplateDialogVisible = true
    },
    onEditTemplate(template) {
      this.editingTemplate = template
      this.addTemplateDialogVisible = true
    },
    onTemplateSubmitted() {
      // Refresh the templates list
      this.onRefreshTemplates()
    },
    onShowAddTemplateDialog() {
      this.onAddNotiTemplate()
    },
    onRefreshTemplates() {
      if (this.fetchingTemplates) return
      // Trigger refresh in the NotificationCard component
      const tabComponent = this.$refs.tabComponent
      if (tabComponent && typeof tabComponent.fetchNotificationTemplates === 'function') {
        tabComponent.fetchNotificationTemplates()
      }
    },
    handleCategoryChange() {
      // Call the child component's method to handle category changes
      const tabComponent = this.$refs.tabComponent
      if (tabComponent && typeof tabComponent.handleCategory === 'function') {
        // Update the child component's data directly
        if (tabComponent.selectedCategory !== undefined) {
          tabComponent.selectedCategory = this.selectedCategory
        }
        if (tabComponent.selectRead !== undefined) {
          tabComponent.selectRead = this.selectRead
        }
        tabComponent.handleCategory()
      }
    },
    handleStatsUpdate(stats) {
      this.notificationStats = stats
    },
    onCreateLetter() {
      const components = Array.isArray(this.$refs.tabComponent)
        ? this.$refs.tabComponent
        : [this.$refs.tabComponent]

      const letterComp = components.find(
        (c) => c && c.$options && c.$options.name === 'LetterTemplates'
      )

      if (letterComp && typeof letterComp.openCreateDialog === 'function') {
        letterComp.openCreateDialog()
      }
    },
    onCreateTrigger() {
      const components = Array.isArray(this.$refs.tabComponent)
        ? this.$refs.tabComponent
        : [this.$refs.tabComponent]

      const triggerComp = components.find(
        (c) => c && c.$options && c.$options.name === 'TemplateTriggers'
      )

      if (triggerComp && typeof triggerComp.openTriggerDialog === 'function') {
        triggerComp.openTriggerDialog()
      }
    }
  },
  mounted() {
    // Set default tab if none is specified in the URL
    if (!this.$route.query.activeTab && this.defaultTabKey) {
      this.$router.replace({
        query: { ...this.$route.query, activeTab: this.defaultTabKey }
      })
    }

    // Remove loading state after component is mounted
    this.$nextTick(() => {
      this.isLoad = false
    })
  }
}
</script>

<style scoped>
.v-tab:before {
  background-color: transparent;
}

.v-tab {
  font-size: 16px;
}

.loading-container {
  position: absolute;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.filter-column {
  width: 300px;
}
</style>
